import { useEffect, useMemo, useState } from "react"

// Small responsive helper used by the dashboard.
// Exposes: isMobile, viewportWidth, pageWidth (with peek), setViewportWidth.
const useViewport = (peekWidth = 48) => {
  const [viewportWidth, setViewportWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  )

  useEffect(() => {
    const onResize = () => setViewportWidth(window.innerWidth)
    window.addEventListener("resize", onResize)
    return () => window.removeEventListener("resize", onResize)
  }, [])

  const isMobile = viewportWidth < 768
  const pageWidth = useMemo(
    () => Math.max(320, viewportWidth - peekWidth),
    [viewportWidth, peekWidth]
  )

  return { isMobile, viewportWidth, setViewportWidth, pageWidth }
}

export default useViewport
